<template>
  <button 
    class="create-btn cursor-pointer"
    style="padding: 1px 2px !important;"
    :class="[
      widthMedium ? 'w-[170px]' : 'w-[140px]',
      widthMaximus ? 'w-[200px]' : 'w-[140px]',
      widthMaximusPlus ? 'w-[220px]' : 'w-[140px]',
    ]"
  >
    <div 
      class="bg-white rounded-sm w-full h-[35px] text-black"
      style="border-radius: 5px;"
    >
      <div 
        class="mt-auto mb-auto h-full flex"
        style="border-radius: 5px;"
      >
        <label class="icon mt-0.5 cursor-pointer">
          <i 
            v-if="typeof icon == 'string'"
            :class="!icon 
              ? 'fas fa-plus' : 
              icon
          "></i>
    
          <component 
            v-else
            :is="icon" 
            class="h-5 w-5" 
          />
    
        </label>
        <p class="text -mt-0.5">
          {{ label }}
        </p>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  name: 'CreateButton',
  props: {
    icon: {
      String,
      default: 'fas fa-plus'
    },
    label: {
      String,
      default: 'Adicionar',
      required: false
    },
    widthMedium: {
      Boolean,
      default: false,
      required: false
    },
    widthMaximus: {
      Boolean,
      default: false,
      required: false
    },
    widthMaximusPlus: {
      Boolean,
      default: false,
      required: false
    },
  }
}
</script>

<style lang="scss" scoped>
.create-btn {
  font-family: monospace !important;
  color: white;
  height: 40px;
  border-radius: 5px;
  border: none;
  background-image: linear-gradient(to right, #92cd24, #0b7037);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition-duration: .5s;
  overflow: hidden;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.103);
  position: relative;

  &:active {
    border: none;
    transform: scale(0.95);
    transition-duration: .5s;
  }

  &:hover {
    border: none;
    box-shadow: 
      #92cd24 0px 4px 8px -2px, 
      #0b7037 0px 0px 0px 1px;
    transform: scale(1.105);

    .text {
      font-weight: normal !important;
      color: #0b7037 !important;
      text-shadow: 1px 1px 80px #92cd24;

    }
  }

  .icon {
    position: absolute;
    left: -50px;
    width: 30px;
    height: 30px;
    background-color: transparent;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    z-index: 2;
    transition-duration: .5s;
    color: #0b7037 !important;
  }

  .text {
    height: 100%;
    width: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 1;
    transition-duration: .5s;
    // font-size: 1.04em;
  }
}

.create-btn {
  &:hover .icon {
    transform: translateX(58px);
    border-radius: 40px;
    transition-duration: 0.3s;
  }

  &:active .icon {
    transform: translateX(58px);
    border-radius: 40px;
    transition-duration: 0.3s;
  }

  &:focus .icon {
    transform: translateX(58px);
    border-radius: 40px;
    transition-duration: 0.3s;
  }
}

.create-btn {
  &:hover .text {
    transform: translate(10px, 0px);
    transition-duration: .5s;
  }
  &:active .text {
    transform: translate(10px, 0px);
    transition-duration: .5s;
  }
  &:focus .text {
    transform: translate(10px, 0px);
    transition-duration: .5s;
  }
}

.text {
  padding-top: 3px;
  letter-spacing: 0.15px !important;
  font-weight: lighter !important;
  color: #000 !important;
  font-size: 1.2em;
  
}
</style>
